export const headerScroll = () => {

  let lastScrollTop = 0;

  const header = document.querySelector('.header')
  const main = document.querySelector('.main')



  window.addEventListener('scroll', () => {
    const headerPosition = header.getBoundingClientRect()
    const mainPosition = main.getBoundingClientRect()
    if (mainPosition.top <= 0) {
      header.classList.add('header--fixed')
    } else {
      header.classList.remove('header--fixed')
    }


    // calculate offset of header on scroll
    const style = window.getComputedStyle(header)
    const matrix = style.transform || style.webkitTransform || style.mozTransform
    let offset = 0;
    if (matrix !== "none") {
      const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
      offset = parseInt(matrixValues[5])
    }



    let st = window.pageYOffset || document.documentElement.scrollTop
    if (st > 550 && st > lastScrollTop){
      if (!header.classList.contains('header--scroll')) {
        header.classList.add('header--scroll')

      }
    } else {
      if (header.classList.contains('header--scroll')) {
        header.classList.remove('header--scroll')

      }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

  }, {passive: true})
}

export default headerScroll
